import React, { FC, ReactNode } from 'react'

import { ListItem, List, Grid, Divider, Box, makeStyles } from '@material-ui/core'

import { BonusScoreToken, MatchEventToken } from 'lib/enumTranslations'
import T from 'components/FormattedMessage'
import { IScoringItem } from 'protos'
import Point from 'components/Point'

import { ScoreItemIcon } from '../../../../components'

type Props = {
  title: ReactNode
  icon: ReactNode
  color: string
  total: number
  items: IScoringItem[]
}

const useStyles = makeStyles(({ typography, spacing }) => {
  return {
    divider: {
      backgroundColor: '#8EA5C2',
      opacity: .22,
    },
    list: {
      margin: 0,
      color: '#8EA5C2',
      fontSize: 14,
      fontWeight: typography.fontWeightMedium,
    },
    listItem: {
      padding: spacing(0, 2, 0, 2),
      marginTop: spacing(1),
    },
    iconContainer: {
      width: spacing(4),
    },
    listItemIconContainer: {
      width: 30,
      height: 30,
      marginRight: spacing(2),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& img': {
        maxWidth: 24,
      },
    },
  }
})

const ScoreItemList: FC<Props> = ({ title, icon, color, total, items }) => {
  const classes = useStyles()

  return (
    <Box mt={3}>
      <Box
        mx={2}
        mb={1}
        fontSize={16}
        color={color}
        fontWeight="fontWeightMedium"
      >
        <Grid
          container
          alignItems="center"
        >
          <Grid
            item
            className={classes.iconContainer}
          >
            {icon}
          </Grid>
          <Grid
            item
            xs
          >
            {title}
          </Grid>
          <Grid item>
            <Point value={total} />
          </Grid>
        </Grid>
      </Box>

      <Divider className={classes.divider} />

      <List className={classes.list}>
        {items.map((item, i) => {
          const labelToken = (
            (item.event && MatchEventToken(item.event)) ||
            (item.bonus && BonusScoreToken(item.bonus))
          )

          if (!labelToken) {
            return null
          }

          return (
            <ListItem
              key={i}
              disableGutters
              className={classes.listItem}
            >
              <Grid
                item
                className={classes.listItemIconContainer}
              >
                <ScoreItemIcon
                  bonus={item.bonus}
                  event={item.event}
                />
              </Grid>
              <Grid item xs>
                <T id={labelToken} /> ( {item.totalCount} )
              </Grid>
              <Grid item>
                <Point
                  explicitPlus
                  value={item.totalValue}
                />
              </Grid>
            </ListItem>
          )
        })}
      </List>
    </Box>
  )
}

export default ScoreItemList
try {
    // @ts-ignore
    ScoreItemList.displayName = "ScoreItemList";
    // @ts-ignore
    ScoreItemList.__docgenInfo = { "description": "", "displayName": "ScoreItemList", "props": { "title": { "defaultValue": null, "description": "", "name": "title", "required": true, "type": { "name": "ReactNode" } }, "icon": { "defaultValue": null, "description": "", "name": "icon", "required": true, "type": { "name": "ReactNode" } }, "color": { "defaultValue": null, "description": "", "name": "color", "required": true, "type": { "name": "string" } }, "total": { "defaultValue": null, "description": "", "name": "total", "required": true, "type": { "name": "number" } }, "items": { "defaultValue": null, "description": "", "name": "items", "required": true, "type": { "name": "any[]" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/PlayerLayer/components/PlayerProfile/tabs/PointspreadTab/components/ScoreItemList/ScoreItemList.tsx#ScoreItemList"] = { docgenInfo: ScoreItemList.__docgenInfo, name: "ScoreItemList", path: "src/components/PlayerLayer/components/PlayerProfile/tabs/PointspreadTab/components/ScoreItemList/ScoreItemList.tsx#ScoreItemList" };
}
catch (__react_docgen_typescript_loader_error) { }